export default __webpack_public_path__ + "static/image6-9ed357181e4275633e7d22120482116b.gif";